/**
 * Capitalize first letter of string
 * i.e. "lorem ipsum" => "Lorem ipsum"
 * @param {string} string
 * @returns string
 */
export const capitalize = (string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

/**
 *
 * @param {string} string
 * @returns string
 */
export const camelToSentenceCase = (string) => {
  return capitalize(string.replace(/([A-Z])/g, ' $1'));
};

/**
 *
 * @param {string} string
 * @returns
 */
export const camelize = (string) => {
  return string.replace(/(?:^\w|[A-Z]|\b\w)/g, (word, index) => {
    return index === 0 ? word.toLowerCase() : word.toUpperCase();
  }).replace(/\s+/g, '');
};

/**
 * Convert string to plural form
 * i.e. "produs" => "produse"
 * @param {string} string
 * @param {int} value
 * @param {object} options
 * @returns string
 */
export const pluralize = (string, value, options = { plural: `${string}s` }) => {
  return value !== 1 ? options.plural : string;
};

/**
 * Truncate string to a maximum length, prepending ellipsis
 * i.e. "lorem ipsum, dolor sit" => "lorem ipsum..."
 * @param {string} string
 * @param {int} maxLength
 * @returns string
 */
export const truncate = (string, maxLength = 10) => {
  if (!string) { return ''; }

  if (string.length <= maxLength) { return string; }

  return `${string.substring(0, maxLength - 3)} ...`;
};

/**
 * Remove diacritics, replacing them with corresponding characters
 * i.e. "adresă" => "adresa"
 * @param {string} string
 * @returns string
 */
export const replaceDiacritics = (string) => {
  if (!string) return '';

  let result = '';
  // eslint-disable-next-line no-restricted-syntax
  for (const c of string) {
    const nc = diacriticsReplace[c] || c;
    result += nc;
  }

  return result;
};

/**
 * Convert a string to a slug
 * by transforming to lower case and replacing spaces with underscore
 * i.e. "Produse de panificatie" => "produse_de_panificatie"
 * @param {string} string
 * @returns string
 */
export const slugify = (string) => {
  return string
    .toLowerCase()
    .trim()
    .replace(/[^\w\s-]/g, '')
    .replace(/[\s_-]+/g, '-')
    .replace(/^-+|-+$/g, '');
};

/**
 * Join an array of string, excluding empty values
 * i.e. ["Bucuresti", "Sector 1", "", "blv. Unirii", "100"] => "Bucuresti, Sector 1, blv. Unirii, 100"
 * @param {array} args
 * @param {string} separator
 * @returns string
 */
export function joinValues(args, separator = ', ') {
  return args?.filter((a) => a && a.trim && a.trim() !== '').join(separator);
}

/* eslint-disable no-bitwise */
export function hashString(s = '') {
  let h = 0;
  let i;
  let chr;

  if (s.length === 0) return h;
  for (i = 0; i < s.length; i++) {
    chr = s.charCodeAt(i);

    h = ((h << 5) - h) + chr;
    h |= 0;
  }
  return h;
}
/* eslint-enable no-bitwise */

// Constants

const diacriticsReplace = {
  ă: 'a',
  â: 'a',
  î: 'i',
  ș: 's',
  ț: 't'
};
